<template>
    <a-modal
        :visible="true"
        title="Dados de entrega do pedido"
        width="30vw"
        ok-text="Aplicar"
        cancel-text="Voltar"
        :ok-button-props="{ props: { disabled: !date || saving } }"
        :confirm-loading="saving"
        :destroy-on-close="true"
        centered
        wrap-class-name="edit-delivery-wrap"
        @ok="apply"
        @cancel="$emit('close')"
    >
        <a-spin :spinning="is_loading || saving">
            <a-form-model layout="vertical">
                <a-form-model-item label="Data de entrega">
                    <a-date-picker
                        v-model="date"
                        :locale="datePickerLocale"
                        style="width: 100%;"
                        format="DD/MM/YYYY"
                        :disabled-date="disabledDate"
                        :allow-clear="false"
                    />
                </a-form-model-item>
                <a-form-model-item label="Cond. de pagamento">
                    <a-select
                        v-model="payment_term_id"
                        show-search
                        option-filter-prop="children"
                        placeholder="Selecione a condição de pagamento"
                        style="width: 100%;"
                    >
                        <a-select-option v-for="term in payment_terms" :key="term.ttp_id" :value="term.ttp_id">
                            {{ term.ttp_nome }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="Faturamento mínimo">
                    <a-input
                        v-model="minimum_billing"
                        prefix="R$"
                        inputmode="numeric"
                        @input="handleBillingInput"
                        @pressEnter="apply"
                    />
                </a-form-model-item>
            </a-form-model>
        </a-spin>
    </a-modal>
</template>

<script>
import moment from "moment";
import "moment/locale/pt-br";
import ptBR from "ant-design-vue/es/date-picker/locale/pt_BR";
import QuotationService from "@/services/QuotationService";

export default {
    props: {
        saving: {
            type: Boolean,
            default: false
        },
        delivery: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            datePickerLocale: ptBR,
            is_loading: true,
            payment_terms: [],
            service: new QuotationService(),
            date: this.initialDate(),
            payment_term_id: this.delivery.payment_term_id || undefined,
            minimum_billing: this.formatPrice(Number(this.delivery.minimum_billing) || 0),
        };
    },
    methods: {
        initialDate() {
            const date = this.delivery.date ? moment(this.delivery.date) : null;
            return date && !date.isBefore(moment(), "day") ? date : null;
        },
        disabledDate(current) {
            return current && current.isBefore(moment(), "day");
        },
        formatPrice(value) {
            return Number(value).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        parsePrice(text) {
            return Number(String(text).replace(/\D/g, "")) / 100;
        },
        handleBillingInput(event) {
            const value = this.formatPrice(this.parsePrice(event.target.value));

            this.minimum_billing = value;
            event.target.value = value;
        },
        apply() {
            if (!this.date) return;

            const term = this.payment_terms.find(t => t.ttp_id == this.payment_term_id);

            this.$emit("apply", {
                date: this.date.format("YYYY-MM-DD"),
                payment_term_id: this.payment_term_id || null,
                form: term ? term.ttp_nome : this.delivery.form,
                minimum_billing: this.parsePrice(this.minimum_billing),
            });
        },
        load_payment_terms() {
            this.service.list_payment_types()
                .then(response => response.data)
                .then(data => {
                    this.payment_terms = data.data;
                    if (!this.payment_term_id && this.delivery.form) {
                        const term = this.payment_terms.find(t => t.ttp_nome == this.delivery.form);
                        if (term) this.payment_term_id = term.ttp_id;
                    }
                })
                .finally(() => {
                    this.is_loading = false;
                });
        }
    },
    created() {
        this.load_payment_terms();
    }
};
</script>
